import React from "react";
import { Box, Typography, BoxProps } from "@material-ui/core";

export const PanelHeader: React.FC<
  {
    icon: React.ReactNode;
    title: string;
    gutter?: number;
  } & BoxProps
> = ({ icon, title, gutter, ...props }) => (
  <Box display="flex" {...props}>
    <Box>{icon}</Box>
    <Box ml={gutter || 2}>
      <Typography variant="h6">{title}</Typography>
    </Box>
  </Box>
);
